<app-auth-pages>
  <ng-container *transloco="let t;">
    <h2 class="card-title fw-bold text-black mb-1 mobile-adjustment">{{t('Login header (Login page) - Login')}}</h2>

    <!-- NEW: Retry-After alert (visible when blocked) -->
    <ngb-alert [type]="'warning'" [dismissible]="false" *ngIf="retryRemainingSeconds > 0">
      <div class="alert-body">
        <p>{{ t('Toaster error message for login (Login page) - Too many failed login attempts. Please try again in seconds', { seconds: retryRemainingSeconds }) }}</p>
      </div>
    </ngb-alert>

    <!-- existing error alert — show only when not blocked -->
    <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error && retryRemainingSeconds === 0">
      <div class="alert-body">
        <p>{{ error }}</p>
      </div>
    </ngb-alert>

    <app-social-logins-links></app-social-logins-links>

    <div class="divider my-2">
      <div class="fw-bold divider-text">{{t('Or text (general) - or')}}</div>
    </div>

    <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onLogin()">
      <div class="form-group">
        <label class="form-label" for="login-email">{{t('Email (general) - Email')}}</label>
        <input type="text" formControlName="email" class="form-control placeholder-text"
          [ngClass]="{ 'is-invalid': submitted && form.email.errors }" placeholder="name@company.com"
          aria-describedby="login-email" autofocus="" tabindex="1" />
        <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
          <div *ngIf="form.email.errors.required"> {{ t('Field required (form validation) - Field name is required', {
            fieldName: t('Email (general) - Email')
            }) }}</div>
          <div *ngIf="form.email.errors.email">{{ t('Email must be a valid email address (general) - Email must be a valid email address') }}</div>
        </div>
      </div>
      <div class="form-group">
        <div class="d-flex justify-content-between">
          <label for="login-password" class="form-label">{{ t('Password - label (general) - Password') }}</label>
          <a routerLink="/forgot-password-v2"><small class="text-secondary">{{ t('Login Forgot Password question (Login page) - Forgot Password')}}?</small></a>
        </div>
        <div class="input-group input-group-merge form-password-toggle">
          <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
            class="form-control form-control-merge placeholder-text"
            [ngClass]="{ 'is-invalid error': submitted && form.password.errors }" placeholder="············"
            aria-describedby="login-password" tabindex="2" />
          <div class="input-group-append">
            <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': passwordTextType, 'icon-eye': !passwordTextType }" (click)="togglePasswordTextType()"></i></span>
          </div>
        </div>
        <div *ngIf="submitted && form.password.errors" class="invalid-feedback"
          [ngClass]="{ 'd-block': submitted && form.password.errors }">
          <div *ngIf="form.password.errors.required">{{ t('Field required (form validation) - Field name is required', {
            fieldName: t('Password - label (general) - Password')
            }) }}</div>
        </div>
      </div>
      <div class="form-group">
        <div class="custom-control custom-checkbox d-flex justify-content-between">
            <div>
              <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" formControlName="remember_me" />
              <label class="custom-control-label checkbox-text" for="remember-me"> {{ t('Remember Me label (Login page) - Remember Me') }}</label>
            </div>
            <div>
              <a routerLink="/sso-login"><small class="text-secondary">Login with SSO</small></a>
            </div>
        </div>
      </div>
      <button [disabled]="loading || retryRemainingSeconds > 0" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>{{ t('Sign in button name (Login
        page) - Sign in') }}
      </button>
    </form>

    <p class="text-center mt-2">
      <span class="text-muted">{{ t('New on our platform text (Login page) - New on our platform') }}?</span><a
        routerLink="/register"><span>&nbsp;{{ t('Create an account link text (Login page) - Create an account')
          }}</span></a>
    </p>

    <p class="text-center mt-2 ">
      <span class="text-muted">{{ t('Still on old platform text (Login page) - Not updated to the new platform yet?')
        }}</span><a href="https://esign.simplesign.io/login"><span>&nbsp;{{ t('Old version login text (Login page) - Switch back to the old version here.') }}</span></a>
    </p>
  </ng-container>
</app-auth-pages>